var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.130969 0.130969C0.305593 -0.0436562 0.588716 -0.0436562 0.76334 0.130969L3.13008 2.49771L5.49682 0.130969C5.67145 -0.0436562 5.95457 -0.0436562 6.12919 0.130969C6.30382 0.305593 6.30382 0.588716 6.12919 0.76334L3.44627 3.44627C3.27164 3.62089 2.98852 3.62089 2.8139 3.44627L0.130969 0.76334C-0.0436562 0.588716 -0.0436562 0.305593 0.130969 0.130969Z",
    fill: "#007672"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.b3b6f439df2820863d65b36fae9398dc.svg";
export { ForwardRef as ReactComponent };